import { Button, Col, Flex, Typography } from "antd";
import { observer } from "mobx-react-lite";
import arrowOut from "images/arrow-out.svg";
import { useStores } from "stores";
import { DIRECTION_TEXT } from "interfaces";
import { Link, useNavigate } from "react-router-dom";
import { routes } from "constants/routes";

import styles from "./header.module.css";

import { DIRECT_PAYMENT_CUSTOMER_LP } from "utils/envConstants";
import { dateFormat } from "utils";

export const BidHeader = observer(() => {
  const { user, bidCard } = useStores();
  const { contract, hid } = bidCard.bid;
  const navigate = useNavigate();
  const { isOperator, isCustomer, isJuniorOperator, isSeniorOperator, isRiskManager, isJuniorLP, isSeniorLP, isLPRiskManager } =
    user.roles;

  const isLpProvider = isJuniorLP || isSeniorLP || isLPRiskManager;
  const isDirectPaymentCustomerLp = isLpProvider && !DIRECT_PAYMENT_CUSTOMER_LP;

  const unkElement = <Typography.Text>Договор УНК {contract.unk}</Typography.Text>;
  const canGoToContractPage = isCustomer || isJuniorOperator || isSeniorOperator || isRiskManager;

  const companyNameElement = <Typography.Text>{contract.companyName}</Typography.Text>;

  return (
    <Flex vertical gap="small">
      <Flex gap="12px" align="center">
        <Button
          type="text"
          variant="filled"
          icon={<img src={arrowOut} alt="arrow-out" />}
          onClick={() => navigate(`/${routes.bids}`)}
          className="bg-basic-300"
        />
        <Flex gap="12px" align="end">
          <Typography.Title className="margin-none">Заявка № {hid}</Typography.Title>
          {canGoToContractPage ? (
            <Link to={`/${routes.contracts}/${contract.id}`} className="hover-underline">
              {!isDirectPaymentCustomerLp && unkElement}
            </Link>
          ) : (
            !isDirectPaymentCustomerLp && unkElement
          )}
          <Typography.Text>
            от {dateFormat(bidCard.bid.created)} на {DIRECTION_TEXT[contract.direction]}
          </Typography.Text>
          {contract.companyName && <Typography.Text>•</Typography.Text>}
          {isOperator ? (
            <Link to={`/${routes.companies}/${contract.companyId}`} className={`${styles.bidCompany} hover-underline`}>
              {!isDirectPaymentCustomerLp && companyNameElement}
            </Link>
          ) : (
            !isDirectPaymentCustomerLp && companyNameElement
          )}
        </Flex>
      </Flex>
    </Flex>
  );
});
